import type { RegisterTranslations } from '../interfaces/register';

export const registerTranslations: RegisterTranslations = {
  register_button: 'Sign up',
  create_account_label_prefix: "Don't have an account?",
  create_account_label_button: 'Sign up',
  or_label: 'Or',
  input_name_label: 'Name',
  input_name_placeholder: 'Enter your name',
  input_last_name_label: 'Last name',
  input_last_name_placeholder: 'Enter your last name',
  terms_and_conditions_text:
    'By signing up, you agree to our terms and conditions.',
};
